import React from 'react';
import { useLocation } from 'react-router-dom';
import camelcaseKeys from 'camelcase-keys';
import queryString from 'query-string';

import BuyPackageContainer from '@src/containers/BuyPackage';
import NewPaymentContainer from '@src/containers/NewPayment';

const Payment = () => {
  const location = useLocation();

  const { orderId, package: packageCode } = camelcaseKeys(
    queryString.parse(location.search) || {},
  );

  const renderPaymentScreen = () => {
    if (orderId || packageCode) {
      return <NewPaymentContainer />;
    }

    return <BuyPackageContainer />;
  };

  return renderPaymentScreen();
};

export default Payment;
